import { render } from "./MyPlan.vue?vue&type=template&id=d024c84e&scoped=true"
import script from "./MyPlan.vue?vue&type=script&lang=js"
export * from "./MyPlan.vue?vue&type=script&lang=js"

import "./MyPlan.vue?vue&type=style&index=0&id=d024c84e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d024c84e"]])

export default __exports__